module.exports = __webpack_public_path__ + "static/media/Outdoor_Sign_Mockup_1.f1a5ae95.png";